(function ($) {

    $(document).ready(function ($) {
        //console.log('v2.1');

        if ($(".section-registration-form").length <= 0) {
            return;
        }

        validate_form();

        // init bootstrap-select.js
        //$('select.selectpicker').selectpicker({});


        // file-upload - filemame on change
        $('.file-upload input[type=file]').on('change', function () {
            var data_text = 'Upload Excel Attachment';
            if ($(this).val() !== '') {
                data_text = $(this).val().replace(/C:\\fakepath\\/i, '');
            }
            $(this).closest('.file-upload').attr('data-text', data_text);
        });


        // add email field on click buttom
        $("#email_statements_to_5, #email_statements_to_4, #email_statements_to_3, #email_statements_to_2").hide().attr("disabled", "disabled");

        $('.wrap.emails .add_email').click(function () {
            $("input[name=email_statements_to]").closest(".wrap.emails").find("input:hidden").first().show().attr("disabled", false);

            if ($("#email_statements_to_5:visible").length >= 1) {
                $(this).fadeOut('slow');
            }
        });

        $('.checkbox label input').after('<span class="cr"><i class="cr-icon fa fa-check"></i></span>');


        function disabled_state() {
            var $this = $("select[name=travel_agency_country],select[name=legal_country],select[name=bank_country]");
            $this.closest('.wrap').next('.wrap').find('select').val('---').attr("disabled", "disabled").addClass('valid').closest('.wrap').removeClass('error').addClass('success').addClass('disable');
            $this.closest('.wrap').next('.wrap').find('.filter-option.pull-left').html('---');
            $this.closest('.wrap').next('.wrap').find('button').attr("disabled", "disabled");
        }

        disabled_state();

        $("select[name=travel_agency_country],select[name=legal_country],select[name=bank_country]").on("change", function () {

            var val = $(this).val();
            if (val !== "United States") {
                $(this).closest('.wrap').next('.wrap').find('select').val('---').attr("disabled", "disabled").addClass('valid').closest('.wrap').removeClass('error').addClass('success').addClass('disable');
                $(this).closest('.wrap').next('.wrap').find('.filter-option.pull-left').html('---');
                $(this).closest('.wrap').next('.wrap').find('button').attr("disabled", "disabled");

            } else {
                $(this).closest('.wrap').next('.wrap').find("select").attr("disabled", false).closest('.wrap').removeClass('disable');
                $(this).closest('.wrap').next('.wrap').find('button').attr("disabled", false);
            }

        });


        // steps toggle function
        $('.step-content:not(:first-child)').removeClass('active').css('display', 'none');

        step_progress();

        jQuery("input[name=travel_agency_legal_address_checkbox]").on('click', function () {
            if (jQuery("input[name=travel_agency_legal_address_checkbox]").is(":checked")) {
                jQuery("input[name=agency_legal_name],input[name=travel_agency_legal_address_line_1], input[name=travel_agency_legal_address_line_2], input[name=travel_agency_legal_address_city],input[name=travel_agency_legal_address_zip], select[name=travel_agency_legal_address_state], select[name=legal_country]").attr("disabled", "disabled").addClass('valid').closest('.wrap').removeClass('error').addClass('success').addClass('disable').find("input, select").next("label").remove();
                jQuery("input[name=agency_legal_name],input[name=travel_agency_legal_address_line_1], input[name=travel_agency_legal_address_line_2], input[name=travel_agency_legal_address_city],input[name=travel_agency_legal_address_zip], select[name=travel_agency_legal_address_state], select[name=legal_country]").rules("remove", "required");
                jQuery("button[data-id=travel_agency_legal_address_state], button[data-id=legal_country]").attr("disabled", "disabled");

            } else {
                jQuery("input[name=agency_legal_name],input[name=travel_agency_legal_address_line_1], input[name=travel_agency_legal_address_line_2], input[name=travel_agency_legal_address_city], input[name=travel_agency_legal_address_zip], select[name=travel_agency_legal_address_state], select[name=legal_country]").closest('.wrap').removeClass('disable');
                jQuery("input[name=agency_legal_name],input[name=travel_agency_legal_address_line_1], input[name=travel_agency_legal_address_line_2], input[name=travel_agency_legal_address_city], input[name=travel_agency_legal_address_zip], select[name=travel_agency_legal_address_state], select[name=legal_country]").attr("disabled", false).rules("add", "required");
                jQuery("button[data-id=travel_agency_legal_address_state], button[data-id=legal_country]").attr("disabled", false);
            }
        });

        $("select[name=travel_agency_country]").on("change", function () {
            var persent = 6;
            var terms_and_services_link = '/wp-content/uploads/2017/06/SurePay-Enrollment-Form-Onyx-_6.pdf';
            var val = $("select[name=travel_agency_country] option:selected").val();
            if (val == "United States") {
                persent = 5;
                var terms_and_services_link = '/wp-content/uploads/2017/06/SurePay-Enrollment-Form-Onyx-_5.pdf';

                $("select[name=bank_state]").attr("disabled", false).closest('.wrap').removeClass('disable').find('button').attr("disabled", false);

            }
            else {
                $("select[name=bank_state]").val('---').attr("disabled", "disabled").addClass('valid').closest('.wrap').removeClass('error').addClass('success').addClass('disable');
                $("select[name=bank_state]").closest('.wrap').find('.filter-option.pull-left').html('---');
                $("select[name=bank_state]").closest('.wrap').find('button').attr("disabled", "disabled");
            }
            $(".service_fee .title i").html(persent);
            $(".checkbox.terms_and_services a").attr('href', terms_and_services_link);

            $('.wpcf7-form-control-wrap.bank_country .dropdown-toggle').removeClass('bs-placeholder').attr('title', val);
            $('.wpcf7-form-control-wrap.bank_country .filter-option').html(val);
            $("select[name=bank_country]").val(val);
        });


        $("select[name=travel_agency_state]").on("change", function () {
            var val = $("select[name=travel_agency_state] option:selected").val();
            $('.wpcf7-form-control-wrap.bank_state .dropdown-toggle').removeClass('bs-placeholder').attr('title', val);
            $('.wpcf7-form-control-wrap.bank_state .filter-option').html(val);
            $("select[name=bank_state]").val(val);

        });


        function active_step() {
            return $('.step-content.active').index() + 1;
        }

        function step_progress() {
            $('.step-progress').removeAttr('class').addClass('step-progress active_step-0' + active_step());
            refresh_validation_rules();
        }

        var offset_form = ($('.section-registration-form').offset().top - 50);

        function next_step($this) {
            $('.step-content').removeClass('active').css('display', 'none');
            $this.closest('.step-content').next().fadeIn('slow').addClass('active');
            step_progress();
            $('body').animate({scrollTop: offset_form}, '500');
        }

        function prev_step($this) {
            $('.step-content').removeClass('active').css('display', 'none');
            $this.closest('.step-content').prev().fadeIn('slow').addClass('active');
            step_progress();
            $('body').animate({scrollTop: offset_form}, '500');
        }

        function validate_form() {
            $('.wpcf7-form').validate({
                rules: {
                    travel_agency_country: {
                        required: true
                    },
                    travel_agency_state: {
                        required: true
                    },
                    travel_agency_legal_address_state: {
                        required: true
                    },
                    legal_country: {
                        required: true
                    },
                    primary_agency_type: {
                        required: true
                    },
                    currency_sure_pay_registration: {
                        required: true
                    },
                    bank_country: {
                        required: true
                    },
                    bank_state: {
                        required: true
                    },
                    bank_address_country: {
                        required: true
                    },
                    i_agree_to_terms_and_conditions: {
                        required: true
                    }
                },
                ignore: ":disabled",
                highlight: function (element) {
                    $(element).closest('.wrap').removeClass('success').addClass('error');
                },
                success: function (element) {
                    element.addClass('valid').closest('.wrap').removeClass('error').addClass('success').find("input, select").next("label").remove();
                }
            });

            $('.wpcf7-form select').on("change", function () {
                $(this).valid();
            });
        }


        $('.pagination .submit').on('click', function () {

            $(".wpcf7-form").valid();


            if (active_step() == 3) {

                if (($('#firstname:visible').val() !== '') && ($('#firstname:visible').val() !== $('#full_name_again:visible').val())) {
                    if (!$('#full_name_again').next('label').length >= 1) {
                        $('#full_name_again').closest('.wrap').addClass('error');
                        $('#full_name_again').after('<label for="email" class="error">Values do not match, please re-enter.</label>')
                        return false;
                    } else {
                        $('#full_name_again').next('.error').remove();
                        $('#full_name_again').after('<label for="email" class="error">Values do not match, please re-enter.</label>')
                        return false;
                    }
                }
                else {
                    $('#full_name_again').closest('.wrap').removeClass('error');
                    $('#full_name_again').next('.error').remove();
                }
            }


            if (active_step() == 2) {
                if (($('#account_iban:visible').val() == '') && ($('#destinaton_id_routing_bic:visible').val() == '')) {

                    $('#account_iban').closest('.wrap').addClass('error');
                    $('#destinaton_id_routing_bic').closest('.wrap').addClass('error');
                    return false;
                }
                if ($('#currency_sure_pay_registration').val() == '') {
                    return false;
                    console.log('hello');
                }
                else {
                    hideErrorsVisibility();
                }
            }


            if ($('.wpcf7-form').find(".wrap.error:visible").length >= 1 || $('.wpcf7-form').find(".wrap.success:visible").length <= 0) {
                return false;
            } else {
                console.log('active_step()', active_step());
                if (active_step() == 3) {
                    //console.log('showLoader!!!()');
                    showLoader();
                }

                next_step($(this));
                hideErrorsVisibility();
            }


        });

        $('.pagination .back').on('click', function () {
            prev_step($(this));
        });

        function hideErrorsVisibility() {
            $('.section-registration-form .wpcf7-form label.error').remove();
            $('.section-registration-form .wpcf7-form .wrap.error').removeClass('error');
        }

        // fix view for last checkbox
        function i_agree_to_terms_and_conditions() {
            // var isChecked = $("input[name=i_agree_to_terms_and_conditions]").is(":checked");
            // if (isChecked) {
            //     $("input[name=i_agree_to_terms_and_conditions]").closest('.wrap').removeClass('error');
            // } else {
            //     $("input[name=i_agree_to_terms_and_conditions]").closest('.wrap').addClass('error');
            // }
            $("input[name=i_agree_to_terms_and_conditions]").closest('.wrap').find('label.error').remove();
        }

        $("input[name=i_agree_to_terms_and_conditions]").on('change', function () {
            i_agree_to_terms_and_conditions();
        });
        $('.pagination .submit').on('click', function () {
            i_agree_to_terms_and_conditions();
        });

        // on/off validation of each step
        function refresh_validation_rules() {
            $.each($(".text_validate"), function () {
                var el = $(this);
                if (el.closest('.step-content.active').length > 0) {
                    el.rules("add", {
                        required: true,
                        minlength: 2
                    });
                } else {
                    el.rules("remove");
                }
            });

            $.each($(".email_validate"), function () {
                var el = $(this);
                if (el.closest('.step-content.active').length > 0) {
                    el.rules("add", {
                        required: true,
                        email: true
                    });
                } else {
                    el.rules("remove");
                }
            });

        }

        // loader
        function showLoader() {
            $('#section-registration-form__loader').addClass('--loading');
            $('.vuec-loader__overlay').fadeIn('slow');
            $('.section-registration-form .step-progress').remove();
            $('.section-registration-form').css('padding-top', '0');
        }
    });

})(jQuery);

(function ($) {
    window.__fill = function () {
        $('input[type="text"]:visible').val('tt');
        $('input[type="tel"]:visible').val('11');
        $('input[type="email"]:visible').val('tt@tt.tt');
        $('#enrolled_agency_id_s_:visible').html('123');
        $('select:visible').each(function () {
            var s = $(this);
            s.val(s.find('option:last').attr('value'));
            s.trigger('change');
        });
    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/registration-form.js